import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'calculateTableHeight' })
export class CalculateTableHeight implements PipeTransform {
  private _defaultPageSize = 5;
  private _headerHeight = 56;
  private _rowHeight = 48;
  private _summary = 0;

  transform(data: any[], summary: boolean, fullHeight: boolean): string {
    if (fullHeight) {
      return '100%';
    }
    if (!data) {
      return this._calculateHeight(0);
    }
    const size = data.length;
    if (summary) {
      this._summary = 48;
    }
    if (size < this._defaultPageSize) {
      return this._calculateHeight(size);
    }

    return this._calculateHeight(this._defaultPageSize);
  }

  private _calculateHeight(size?: number): string {
    return `${size * this._rowHeight + this._headerHeight + this._summary}px`;
  }
}
